export default __webpack_public_path__ + "static/not fond-a7455bec558adc8856dc215921628708.svg";